import React from 'react';
import { motion } from 'framer-motion';
import { CalendarDots, ShieldCheck } from '@phosphor-icons/react';

const BACKEND_URL = window.location.origin;

function Login() {
  const handleGoogleLogin = () => {
    document.cookie = 'session_token=; path=/; max-age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT';
    document.cookie = 'O_session_token=; path=/; max-age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT';
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col pt-[env(safe-area-inset-top)]">
      <div className="flex-1 flex items-center justify-center p-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="max-w-md w-full"
        >
          <div className="text-center mb-8">
            <img
              src="/helmcore-logo.png"
              alt="Helm Core"
              className="w-32 h-auto mx-auto mb-4 object-contain"
            />
            <p className="text-base text-slate-500 leading-relaxed">
              Your professional workflow operating system. Organize tasks, documents, and reminders in one calm place.
            </p>
          </div>

          <div className="bg-white border border-slate-200 rounded-lg p-6 md:p-8">
            <button
              onClick={handleGoogleLogin}
              data-testid="google-login-btn"
              className="w-full bg-navy text-white hover:bg-navy-hover transition-all duration-200 font-medium px-4 py-3 rounded-lg flex items-center justify-center gap-3 shadow-sm hover:shadow-md"
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M19.6 10.227c0-.709-.064-1.39-.182-2.045H10v3.868h5.382a4.6 4.6 0 01-1.996 3.018v2.51h3.232c1.891-1.742 2.982-4.305 2.982-7.35z" fill="#4285F4"/>
                <path d="M10 20c2.7 0 4.964-.895 6.618-2.423l-3.232-2.509c-.895.6-2.04.955-3.386.955-2.605 0-4.81-1.76-5.595-4.123H1.064v2.59A9.996 9.996 0 0010 20z" fill="#34A853"/>
                <path d="M4.405 11.9c-.2-.6-.314-1.24-.314-1.9 0-.66.114-1.3.314-1.9V5.51H1.064A9.996 9.996 0 000 10c0 1.614.386 3.141 1.064 4.49l3.34-2.59z" fill="#FBBC05"/>
                <path d="M10 3.977c1.468 0 2.786.505 3.823 1.496l2.868-2.868C14.959.99 12.695 0 10 0 6.09 0 2.71 2.24 1.064 5.51l3.34 2.59C5.191 5.736 7.396 3.977 10 3.977z" fill="#EA4335"/>
              </svg>
              Continue with Google
            </button>

            <div className="mt-6 pt-6 border-t border-slate-200 space-y-3">
              <div className="flex items-start gap-3 text-sm text-slate-500">
                <CalendarDots size={18} className="text-navy flex-shrink-0 mt-0.5" />
                <p className="leading-relaxed">
                  Reduce mental load by tracking deadlines, documents, and recurring responsibilities.
                </p>
              </div>
              <div className="flex items-start gap-3 text-sm text-slate-500">
                <ShieldCheck size={18} className="text-navy flex-shrink-0 mt-0.5" />
                <p className="leading-relaxed">
                  Your data stays private. Secure authentication powered by Google OAuth.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default Login;
